<template>
  <div class="popFixed new-withdrawal-certify">
    <div class="masking" @click="closeMe" />
    <div id="tcConHeight" class="tcCon">
      <div class="item">
        <span>温馨提示</span>
        <ul class="my-ul">
          <li>经银行卡取款，需身份证明及银行卡</li>
          <li>其他方式取款，需身份证明</li>
        </ul>
      </div>
      <div class="btnCon" :class="pageType === 'app' ? 'only' : ''">
        <span v-if="pageType !== 'app'" @click="closeMe">取消</span>
        <span @click="goToWithdraw">继续取款</span>
        <span @click="goPersonalInfo">去认证</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NewWithdrawalWithUSDT',
  components: {},
  props: ['source', 'isShowNewWithdrawalModule', 'pageType'],
  data() {
    return {
      // isShow: this.isShowNewWithdrawalModule,
    }
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    closeMe() {
      if (this.pageType !== 'app') {
        if (this.source === 'home') {
          this.removeFixed()
          this.$emit('changeNewWithdrawalWithUSDT', false)
        } else {
          this.$router.go(-1)
        }
      }
    },
    goPersonalInfo() {
      this.$bus.$emit('loading', false)
      this.$router.push({
        path: '/home/personalInfo'
      })
    },
    goToWithdraw() {
      this.$emit('allowToWithdrawal')
    }
  }
}
</script>
